import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseMagLandings } from "../UseMagLandings";
import { useRecoilState } from "recoil";
import { rsProgress, rsParentCom } from "../../../RecoilStates";
import CustomPagination from "../../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";

export default function ProductsGrid(props) {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { GetLandingItems, deleteLandingGroup, UpdateLandingGroup } =
    UseMagLandings();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [items, setItems] = useState("");
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  useEffect(() => {
    setProgress(true);
    GetLandingItems(props.LandingID, (callback) => {
      setItems(callback.groups);
    });
  }, [props.LandingID]);

  useEffect(() => {
    setFilt([
      {
        columnField: "productName",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    if (props.landingInfo && props.landingInfo.id) {
      return navigate("/magmanagment/LandingsManage/AddGroup", {
        state: {
          search: searchSubGroup,
          groupsLength: items,
          thisOfferId: props.LandingID,
          componentFaTitle: location.state.componentFaTitle,
          LandingID: props.componentAID,
          parentUrl: msParentCom.parentComs,
        },
      });
    } else {
      enqueueSnackbar("ابتدا اطلاعات فوق را ثبت کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      // hide: true,
    },
    {
      field: "title",
      headerName: "نام گروه",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  return navigate("/magmanagment/LandingsManage/EditGroup", {
                    state: {
                      search: searchSubGroup,
                      groupsLength: items,
                      thisOfferId: props.LandingID,
                      componentFaTitle: location.state.componentFaTitle,
                      LandingID: props.componentAID,
                      model: cellValues.row,
                      allGroups: items,
                      parentUrl: msParentCom.parentComs,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                  // hid: props.componentAID,
                  // groupID: props.LandingID,
                };

                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  UpdateLandingGroup(model, () => {
                    setProgress(true);
                    GetLandingItems(props.LandingID, (callback) => {
                      setItems(callback.groups);
                    });
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == items.length + 1) {
                  return;
                } else {
                  UpdateLandingGroup(model, () => {
                    setProgress(true);
                    GetLandingItems(props.LandingID, (callback) => {
                      setItems(callback.groups);
                    });
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو گروه"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={items ? items : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={items && items.length ? items.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            // nofab: true,
            // isRefresh: true,
            isLtr: true,
            rowCount: items && items.length ? items.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"گروه"}
        callback={() => {
          setProgress(true);
          deleteLandingGroup(deleteState.id, () => {
            GetLandingItems(props.LandingID, (callback) => {
              setItems(callback.groups);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
